import { DealerModelPrice } from "./dealerModelPrice";

export class DealerModelConfig {
    dealerId: string;
    applicableOn?: string = "Both";
    dealerModelPrices: DealerModelPrice[];
    public constructor(init?: Partial<DealerModelConfig>) {
        Object.assign(this, init);
    }
}